module.exports = __webpack_public_path__ + "static/media/login.891f8bde.png";